import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { decompress } from 'lz-string';
import { Subject, BehaviorSubject, takeUntil, combineLatest, map, of, startWith, delay, take } from 'rxjs';
import { Users } from 'src/app/Interfaces/users';
import { StoreService } from 'src/app/services/store.service';
import { ClientWalkOrder, ClientWalkOrderPatchBody, ClientWalkOrderPossibleDays, ClientWalkOrderPossibleValues, clientWalkOrderValues } from 'src/app/Interfaces/reports';
import { MatDialog } from '@angular/material/dialog';
import { ClientWalkDialogComponent } from './dialog/dialog.component';
import { BottomPopupService } from 'src/app/services/bottom-popup.service';
import { DeviceInfoService } from 'src/app/services/device-info.service';
import { dayToHebrewDay } from 'src/app/Utility/functions';
import { environment } from 'src/environments/environment';

type ClientWalkOrderDaysForm = { [k in ClientWalkOrderPossibleDays]: boolean };

@Component({
	selector: 'app-client-walk-order',
	templateUrl: './client-walk-order.component.html',
	styleUrls: ['./client-walk-order.component.scss'],
})
export class ClientWalkOrderComponent implements OnInit, OnDestroy {
	_ss = inject(StoreService);
	router = inject(Router);
	private dialog = inject(MatDialog);
	private _bottomPopup = inject(BottomPopupService);
	private _device = inject(DeviceInfoService);
	private fb = inject(FormBuilder);

	constructor() {}

	form = this.fb.nonNullable.group({
		Search: [''],
		Agent: [<string[]>[]],
	});

	mustPickDatePopup = true;
	hasPickedAtLeastOnce = false;

	AgentArray$ = new BehaviorSubject<Users[]>([]);
	AgentIDToName$ = this.AgentArray$.pipe(
		map(agents => {
			return agents.reduce((acc, curr) => {
				acc[curr.AgentID] = curr.UserName;
				return acc;
			}, {});
		}),
	);

	selectedDay$ = new BehaviorSubject<{ day: ClientWalkOrderPossibleDays | null }>({ day: null });
	walkOrder$ = new BehaviorSubject<ClientWalkOrder[]>([]);
	walkOrderDisplay$ = combineLatest([this.walkOrder$, this.form.controls.Search.valueChanges.pipe(startWith('')), this.AgentIDToName$, this.selectedDay$]).pipe(
		map(([walkOrder, search, agentName, selectedDay]) => {
			if (search) {
				const splitValue = search.split(' ').map(v => v.toLowerCase());
				const arr = [];

				for (let i = 0; i < walkOrder.length; i++) {
					let counter = 0;

					const { ClientID, ClientName, AgentID } = walkOrder[i];
					const AgentName = agentName[AgentID];

					const ClientIDWithoutSpaces = (ClientID || '').replace(/\s/g, '').toLowerCase(),
						ClientNameWithoutSpaces = (ClientName || '').replace(/\s/g, '').toLowerCase(),
						AgentNameWithoutSpaces = (AgentName || '').replace(/\s/g, '').toLowerCase(),
						allStrings = typeof ClientIDWithoutSpaces === 'string' && typeof ClientNameWithoutSpaces === 'string' && typeof AgentNameWithoutSpaces === 'string';

					if (allStrings) {
						for (let j = 0; j < splitValue.length; j++) {
							if (
								(ClientNameWithoutSpaces && ClientNameWithoutSpaces.indexOf(splitValue[j]) > -1) ||
								(ClientIDWithoutSpaces && ClientIDWithoutSpaces.indexOf(splitValue[j]) > -1) ||
								(AgentNameWithoutSpaces && AgentNameWithoutSpaces.indexOf(splitValue[j]) > -1)
							) {
								counter++;
							}
						}
					}

					if (counter === splitValue.length) {
						arr.push(walkOrder[i]);
					}
				}
				walkOrder = arr;
			}
			const objectsWithWalkOrderValue = walkOrder.filter(obj => obj.WalkOrder && obj.WalkOrder !== '0');
			const objectsWithoutWalkOrderValue = walkOrder.filter(obj => !obj.WalkOrder || obj.WalkOrder === '0');

			objectsWithWalkOrderValue.sort((a, b) => {
				return +a.WalkOrder - +b.WalkOrder;
			});
			const day = selectedDay.day;

			if (day) {
				objectsWithWalkOrderValue.sort((a, b) => {
					if (+a[day] && !+b[day]) return -1;
					if (!+a[day] && +b[day]) return 1;
					return 0;
				});
			}

			return [...objectsWithWalkOrderValue, ...objectsWithoutWalkOrderValue];
		}),
	);

	BizoimCompany;

	toogleInputNew = false;
	ShowCompanys = null;
	HasMultipleCompanys;
	reportSearch = null;

	destroy$ = new Subject<void>();

	loadingMainQuery = false;

	windowWidth: number;

	isAdmin = location.pathname.includes('admin');

	loadingAgents = false;

	hasGetAgentSalesNextQuery = false;
	hasGetAgentOrdersNextQuery = false;

	First = true;
	FirstScrollY = 0;
	Second = false;
	Third = false;

	agentsToGet = [];

	productIDChosen = '';

	title$ = of('ניהול תכנון מסלול');
	daysArray: Array<ClientWalkOrderPossibleDays> = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

	checkboxesForm = this.fb.nonNullable.group(Object.fromEntries(this.daysArray.map(day => [day, true])) as ClientWalkOrderDaysForm);

	daysHeaders$ = combineLatest([this.checkboxesForm.valueChanges.pipe(startWith(this.checkboxesForm.value))]).pipe(
		map(([checkboxes]): Array<ClientWalkOrderPossibleDays> => {
			return Object.entries(checkboxes).reduce((acc, [day, isChecked]) => {
				if (isChecked) {
					acc.push(day);
				}
				return acc;
			}, []);
		}),
	);

	tableHeight: string | number = '';

	clientWalkTooltip = clientWalkOrderValues.map(({ value, text }) => `${value} - ${text}`).join('\n');

	ngOnInit(): void {
		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////
		if (this._ss.CustomerInformation === null) {
			if (localStorage.getItem('CustomerInformation') !== null) {
				this._ss.CustomerInformation = decompress(localStorage.getItem('CustomerInformation'));
				this._ss.CustomerInformation = JSON.parse(this._ss.CustomerInformation);
			}
		}
		//////////////////// ---------- CLIENT INFORMATION ---------- ////////////////////

		this.HasMultipleCompanys = localStorage.getItem('HasMultipleCompanys');

		this.windowWidth = window.innerWidth;

		if (this.HasMultipleCompanys === '2') {
			if (localStorage.getItem('ShowCompanys') !== null) {
				this.ShowCompanys = localStorage.getItem('ShowCompanys');
				this.ShowCompanys = JSON.parse(this.ShowCompanys);
			} else {
				this._ss.GetComppanys().subscribe(res => {
					this.ShowCompanys = res;
					this.ShowCompanys = this.ShowCompanys.recordset;
					localStorage.setItem('ShowCompanys', JSON.stringify(this.ShowCompanys));
				});
			}
		}

		if (this.isAdmin) {
			this.loadingAgents = true;

			this.getAgents();
		}

		window.scrollTo(0, 0);

		if (!localStorage.getItem('UserName') && !localStorage.getItem('AgentId')) {
			this.router.navigate(['login']);
			return;
		}

		this._ss.UserNameConnected = localStorage.getItem('UserName');
		this._ss.AgentIdConnected = localStorage.getItem('AgentId');
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	recalculateTableHeight() {
		combineLatest([this._device.isDesktopResolution$, this._device.isNotTabletResolution$])
			.pipe(take(1), delay(0))
			.subscribe(shouldNotMultiplyByZoom => {
				const total = document.querySelector('table').getBoundingClientRect().top;
				this.tableHeight = `calc(99vh - ${shouldNotMultiplyByZoom.some(Boolean) ? total : total * 1.2}px)`;
			});
	}

	toggleDaySelected(day: ClientWalkOrderPossibleDays) {
		this.selectedDay$.next({ day: this.selectedDay$.value.day === day ? null : day });
	}

	handleClosePopup() {
		this.mustPickDatePopup = false;
		if (!this.hasPickedAtLeastOnce) {
			history.back();
			return;
		}
	}

	handleFormSubmit() {
		this.loadingMainQuery = true;

		let { Agent } = this.form.value;

		let agents = [];

		if (!this.isAdmin) {
			agents.push(this._ss.AgentIdConnected);
		}

		if (this.isAdmin && Agent && Agent.length) {
			agents = Agent;
		}

		this._ss.getClientWalkOrder(agents).subscribe({
			next: res => {
				if (res === 'ConnectionError' || res === 'RequestError') {
					this.handleError();
					return;
				}

				this.walkOrder$.next(res.recordset);

				this.mustPickDatePopup = false;
				this.hasPickedAtLeastOnce = true;

				this.loadingMainQuery = false;

				this.form.controls.Search.setValue(this.form.controls.Search.value);

				this.recalculateTableHeight();
			},
			error: err => {
				this.handleError();
			},
		});
	}

	updateAfterDialogClosed(input: { day: ClientWalkOrderPossibleDays; dayValue: string; newWalkOrder: string; ClientID: string; agentID?: string }) {
		const { ClientID, day, dayValue, newWalkOrder, agentID } = input;

		let duplicateWalkOrder = this.walkOrder$.value.find(obj => obj.WalkOrder === newWalkOrder && obj.AgentID === agentID && obj.ClientID !== ClientID);

		if (duplicateWalkOrder) {
			if (duplicateWalkOrder.WalkOrder === newWalkOrder && duplicateWalkOrder.ClientID === ClientID && duplicateWalkOrder[day] === dayValue) {
				return;
			}
			if (newWalkOrder && newWalkOrder !== '0') {
				this.handleMoveAllConflictingWalkOrders(input);
				return;
			}
		}

		this._ss.patchClientWalkOrder({ ClientID, WalkOrder: newWalkOrder, day, dayValue }).subscribe({
			next: res => {
				if (res === 'ConnectionError' || res === 'RequestError') {
					this.handleError();
					return;
				}

				this._bottomPopup.show('הפריט עודכן בהצלחה');

				this.handleFormSubmit();
			},
			error: err => {
				this.handleError();
			},
		});
	}

	handleError() {
		alert('ישנה תקלת תקשורת, אנא נסה שנית מאוחר יותר');
		history.back();
		return;
	}

	handleMoveAllConflictingWalkOrders(input: { day: ClientWalkOrderPossibleDays; dayValue: string; newWalkOrder: string; ClientID: string; agentID?: string }) {
		const { day, dayValue, newWalkOrder, ClientID } = input;
		let relevantWalkOrders = this.walkOrder$.value.filter(obj => +obj.WalkOrder && +obj.WalkOrder >= +newWalkOrder && obj.ClientID !== ClientID && obj.AgentID === input.agentID);

		// if (environment.development) {
		// 	relevantWalkOrders = relevantWalkOrders.filter(obj => obj.AgentID === input.agentID);
		// }

		let body: ClientWalkOrderPatchBody[] = relevantWalkOrders.map(obj => ({
			ClientID: obj.ClientID,
			WalkOrder: (+obj.WalkOrder + 1).toString(),
		}));
		// if (environment.development) {
		// 	for (const obj of body) {
		// 		obj.WalkOrder = '0';
		// 	}
		// }
		body.push({ ClientID, WalkOrder: newWalkOrder, day, dayValue });
		this._ss.patchMultipleClientWalkOrder({ lines: body }).subscribe({
			next: res => {
				if (res === 'ConnectionError' || res === 'RequestError') {
					this.handleError();
					return;
				}

				this._bottomPopup.show('הפריט עודכן בהצלחה');

				this.handleFormSubmit();
			},
			error: err => {
				this.handleError();
			},
		});
	}

	SearchClear() {
		this.form.controls.Search.reset();

		this.clearEverything();
	}

	//TODO refactor into two different methods

	clearEverything() {
		// this.form.reset();
	}

	public ChangeCompany() {}

	handleNavigation() {
		history.back();
		return;
	}

	async getAgents(): Promise<void> {
		if (this._ss.CustomerInformation.Submanagers === '1') {
			this.agentsToGet = await this.getSubmanagerAgentsFirst();
		}

		this.getAgentUsers();
	}

	async getSubmanagerAgentsFirst(): Promise<string[]> {
		return await new Promise(resolve => {
			if (!this._ss.agentsOfSubmanager.length) {
				this._ss.getAdminAgents().subscribe({
					next: res => {
						if (typeof res === 'string') {
							alert('חלה תקלה בהבאת סוכנים עבור מנהל זה. נסו שנית');
							resolve([]);
							history.back();
							return;
						}

						const agents = res.recordset.map(obj => obj.Agent);
						agents.push(this._ss.AgentIdConnected);
						this._ss.agentsOfSubmanager = agents;

						return resolve(agents);
					},
					error: err => {
						alert('שגיאת שרת');
					},
				});
			} else {
				resolve(this._ss.agentsOfSubmanager);
			}
		});
	}

	getAgentUsers() {
		this._ss.GetAllAgents(this.agentsToGet).subscribe({
			next: res => {
				if (res === 'ConnectionError' || res === 'RequestError') {
					alert('אירעה שגיאה בקבלת נתונים מהשרת, אנא נסה שנית');
					history.back();
					return;
				}

				this.AgentArray$.next(res.recordset);
				this.loadingAgents = false;
			},
			error: err => {
				alert('אירעה שגיאה בקבלת נתונים מהשרת, אנא נסה שנית');
				history.back();
			},
		});
	}

	handleDayClick(row: ClientWalkOrder, day: ClientWalkOrderPossibleDays) {
		const body = {
			ClientID: row.ClientID,
			day,
		};
		const ref = this.dialog.open(ClientWalkDialogComponent, {
			data: {
				day,
				row,
			},
		});

		ref.afterClosed().subscribe((res?: { dayValue: string; walkOrder: string }) => {
			if (res && res.dayValue != undefined && res.walkOrder != undefined) {
				this.updateAfterDialogClosed({ ...body, newWalkOrder: res.walkOrder, dayValue: res.dayValue, agentID: row.AgentID });
			}
		});
	}

	trackBy(index: number, walkOrder: ClientWalkOrder): string {
		return walkOrder.ClientID;
	}

	indexToDay(index: number): ClientWalkOrderPossibleDays {
		switch (index) {
			case 0:
			default:
				return 'Sunday';
			case 1:
				return 'Monday';
			case 2:
				return 'Tuesday';
			case 3:
				return 'Wednesday';
			case 4:
				return 'Thursday';
			case 5:
				return 'Friday';
			case 6:
				return 'Saturday';
		}
	}

	dayToHebrewDay = dayToHebrewDay;
}
